import styles from './style.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from '../../../components/Common/Button'
import videoPlaceholder from "./placeHolder.jpg"
import underLine from "./underline.svg"
import { useContext, useEffect } from 'react'
import mainContext from '../../../context/mainContext'

const textFake = ["Hi to using  ", " web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."]
const titleFake = "Payments are calculated at the end of every month for"

// Creator : Team h
function Instructions({ navigateTo, textList = textFake, title = titleFake, vidSrc, iframe }) {

    const navigate = useNavigate()

    const { header: { setPageName } } = useContext(mainContext)

    const { state } = useLocation()

    useEffect(() => {
        setPageName("Instructions".toUpperCase())
        return () => setPageName("")
    }, [])

    const onclick = () => navigate(navigateTo, { state })

    return (
        <div className={styles.container} style={window.buildType === "iPhone" ? { minHeight: "85dvh" } : {}}>
            {/* <img src={videoPlaceholder} alt="video place holder" /> */}
            {/* <iframe src="https://www.youtube.com/embed/ANiVNut2n60?si=2OBuoTzlrYcHMjBU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
            {iframe}
            <h2 >{title}</h2>
            <img className={styles.underline} src={underLine} alt="underline" />
            {textList?.map((text, i) => <p style={{ textAlign: "center" }} key={`k${i}`}>{text}</p>)}
            <Button title={"NEXT"} startFunction={onclick}></Button>
        </div>
    )
}

export default Instructions